import React, { useEffect, useState, useCallback  } from "react";
import axios from "axios";

import ProjectViewSheet from "./ProjectViewSheet";

const ProjectDetailModal = ({ project, onClose }) => {
  const [projectTasks, setProjectTasks] = useState([]);

  const fetchProjectTasks = useCallback(() => {
    if (!project?.project_id) return;

    axios
      .get(`/api/mainpagepopupproject.php?project_id=${project.project_id}`, {
        withCredentials: true,
      })
      .then((res) => setProjectTasks(res.data))
      .catch((err) => console.error("Error fetching project tasks:", err));
  }, [project?.project_id]);

  useEffect(() => {
    fetchProjectTasks();
  }, [fetchProjectTasks]);




  if (!project) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-40 backdrop-blur-sm">
      <div className="bg-white p-6 rounded-xl shadow-lg w-[99%]  h-[98vh] overflow-y-auto relative">
        <button
          className="absolute top-2 right-3 text-gray-600 hover:text-red-500 text-xl"
          onClick={onClose}
        >
          &times;
        </button>

        <h2 className="text-xl font-bold mb-4">Project: {project.project_id}</h2>

        <div className="flex justify-between mb-3">
          <p className="text-gray-700 font-medium text-sm">Tasks: {projectTasks.length}</p>
          
        </div>

        <div className="overflow-x-auto bg-white shadow-md rounded-xl border border-gray-200">
          <table className="w-full divide-y divide-gray-200">
            <thead className="bg-gray-100 text-gray-700 text-xs uppercase tracking-wider">
              <tr>
                <th className="px-4 py-3 text-left">Task ID</th>
                <th className="px-4 py-3 text-left">Task Name</th>
                <th className="px-4 py-3 text-left">Assigned</th>
                <th className="px-4 py-3 text-left">Status</th>
                <th className="px-4 py-3 text-left">Priority</th>
                <th className="px-4 py-3 text-left">Start Date</th>
                <th className="px-4 py-3 text-left">Tentative Time</th>
                <th className="px-4 py-3 text-center" colSpan="3">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {projectTasks.map((task) => (
                <tr key={task.id} className="hover:bg-gray-50 transition duration-200 text-xs">
                  <td className="px-4 py-2 text-blue-600 font-medium cursor-pointer hover:underline">
                    {task.task_id}
                  </td>
                  <td className="px-4 py-2">{task.task_name}</td>
                  <td className="px-4 py-2">{task.assign_to}</td>
                  <td className="px-4 py-2">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-semibold ${
                        task.status === "To Do"
                          ? "bg-yellow-200 text-yellow-800"
                          : task.status === "Doing"
                          ? "bg-blue-200 text-blue-800"
                          : "bg-green-200 text-green-800"
                      }`}
                    >
                      {task.status}
                    </span>
                  </td>
                  <td className="px-4 py-2">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-semibold ${
                        task.priority === "Urgent"
                          ? "bg-red-400 text-white"
                          : "bg-green-100 text-green-800"
                      }`}
                    >
                      {task.priority}
                    </span>
                  </td>
                  <td className="px-4 py-2">
                    {task.start_date || <span className="text-gray-400">dd-mm-yyyy</span>}
                  </td>
                  <td className="px-4 py-2">
                    {task.submission_date }<span> hr</span>
                  </td>
                  
                  <td className="px-4 py-2 text-center">🗑️</td>
                </tr>
              ))}

            
            </tbody>
          </table>
        </div>
<ProjectViewSheet projectId={project.project_id} refreshTasks={fetchProjectTasks} />

      </div>
    </div>
  );
};

export default ProjectDetailModal;
